export const PEOPLE = 'people';

export default {
  [PEOPLE]: {
    es: '/people',
    en: '/people',
    fr: '/people',
  },
};
